var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.3 10.167h1.47v1.425H7.3zm-1.8-3.55q.06-1.405.981-1.992.582-.375 1.43-.375 1.115 0 1.85.533.74.532.739 1.577 0 .642-.32 1.08-.187.267-.72.68l-.35.272a1.06 1.06 0 0 0-.38.518q-.06.188-.064.582H7.334q.03-.834.158-1.15.129-.32.66-.734l.36-.281q.179-.134.287-.291a1 1 0 0 0 .197-.597q0-.375-.222-.68-.216-.31-.799-.31-.571 0-.813.379a1.47 1.47 0 0 0-.237.789z"
})));
export default SvgHelp;